import {
  Inject,
  Injectable,
  Optional,
  Renderer2,
  SkipSelf,
  InjectionToken,
  DOCUMENT,
} from "@angular/core";

import { WINDOW } from "shared/helper-services/window-token.module";

import { Subject } from "rxjs";

import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class BfxDocumentMouseLeaveService {
  private documentMouseLeaveSubject = new Subject<Event>();
  public $documentMouseLeave = this.documentMouseLeaveSubject.asObservable();

  constructor(
    @Inject(DOCUMENT) private document: any,
    @Inject(WINDOW) private window: any,
  ) {
    let mouseleaveRef = this.onMouseLeave.bind(this);

    document.addEventListener("mouseleave", mouseleaveRef, { passive: true });
  }

  protected onMouseLeave($event) {
    this.documentMouseLeaveSubject.next($event);
  }
}
